import { useState } from 'react'
import {
  Box, FormControl, InputLabel, Select, MenuItem, TextField,
  ListItemIcon, ListItemText, Divider,
} from '@mui/material'
import { CreateNewFolder } from '@mui/icons-material'

export default function FolderSelector({ folders, selectedFolderId, onSelect, onCreateFolder }) {
  const [creating, setCreating] = useState(false)
  const [newName, setNewName] = useState('')

  const handleStartCreate = () => {
    const today = new Date().toISOString().slice(0, 10)
    setNewName(today)
    setCreating(true)
  }

  const handleConfirmCreate = () => {
    const name = newName.trim()
    if (!name) return
    onCreateFolder(name)
    setCreating(false)
    setNewName('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirmCreate()
    if (e.key === 'Escape') { setCreating(false); setNewName('') }
  }

  if (creating) {
    return (
      <TextField
        autoFocus
        size="small"
        label="Folder Name"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleConfirmCreate}
        sx={{ minWidth: 200 }}
      />
    )
  }

  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Folder</InputLabel>
      <Select
        value={selectedFolderId || ''}
        label="Folder"
        onChange={(e) => {
          if (e.target.value === '__new__') {
            handleStartCreate()
          } else {
            onSelect(e.target.value)
          }
        }}
        renderValue={(val) => {
          const folder = folders.find((f) => f.id === val)
          return folder?.name || 'All Plans'
        }}
      >
        {folders.map((f) => (
          <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
        ))}
        {folders.length > 0 && <Divider />}
        <MenuItem value="__new__">
          <ListItemIcon><CreateNewFolder fontSize="small" /></ListItemIcon>
          <ListItemText>New Folder</ListItemText>
        </MenuItem>
      </Select>
    </FormControl>
  )
}
